import { decodeJwt } from "jose";

/**
 *
 * @returns {string | null}
 */
export const getUsername = () => {
  const accessToken = localStorage.getItem("access_token");
  if (!accessToken) return null;

  const decoded = decodeJwt(accessToken);
  return decoded.username ?? null;
};
